import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { BusinessModuleRef } from '../../models/serializable/business-module-ref.js';
import { MapUtils } from '../../utility/map-utils.js';
import { RenderableComponent } from '../core/component.js';

export class ReviewComponent extends RenderableComponent {
  static readonly TYPE_ID: string = 'cfdbe5c2271e4436af10d89def9128f8';
  static readonly DEFAULT_RENDER_ORDER: number = 19;

  constructor(
    public readonly businessRef: BusinessModuleRef | null,
    public readonly renderOrder: number,
    public readonly isRenderingEnabled: boolean,
  ) {
    super();
  }

  get $typeId() {
    return ReviewComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return true;
  }

  static fromMap(context: SerializationContext, map: SerializedData): ReviewComponent {
    return new ReviewComponent(
        BusinessModuleRef.decode(MapUtils.getOrNull<string>(map, 'businessRef')),
        MapUtils.get<number>(map, 'renderOrder'),
        MapUtils.get<boolean>(map, 'isRenderingEnabled'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'businessRef': this.businessRef?.encode() ?? null,
      'renderOrder': this.renderOrder,
      'isRenderingEnabled': this.isRenderingEnabled,
    };
  }

  clone(): this {
    return new ReviewComponent(
        this.businessRef?.clone() ?? null,
        this.renderOrder,
        this.isRenderingEnabled,
    ) as this;
  }

  isSame(other: ReviewComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.businessRef, this.businessRef) &&
      other.renderOrder === this.renderOrder &&
      other.isRenderingEnabled === this.isRenderingEnabled;
  }
}

export class ReviewComponentBuilder extends DataModelBuilder<ReviewComponent> {
  build(context: SerializationContext, map: SerializedData): ReviewComponent {
    return ReviewComponent.fromMap(context, map);
  }
}
